import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RouteHandlingService {
  private router = inject(Router);

  public handleRoute(state: RouterStateSnapshot): boolean {
    const activeFlags = this.getActiveFlags();

    if (activeFlags.length === 1) {
      const singleFlag = activeFlags[0];

      if (singleFlag === 'agrinio') {
        if (!state.url.startsWith('/access-control')) {
          this.router.navigate(['/access-control']);
          return false;
        }
      }

      if (singleFlag === 'flexi') {
        if (!state.url.startsWith('/flexi')) {
          this.router.navigate(['/flexi']);
          return false;
        }
      }

      if (singleFlag === 'aigaleo') {
        if (!state.url.startsWith('/aigaleo')) {
          this.router.navigate(['/aigaleo']);
          return false;
        }
      }

      if (singleFlag === 'fleet') {
        if (!state.url.startsWith('/fleet')) {
          this.router.navigate(['/fleet']);
          return false;
        }
      }

      if (singleFlag === 'mediaServer') {
        if (!state.url.startsWith('/media-server')) {
          this.router.navigate(['/media-server']);
          return false;
        }
        return true;
      }

      if (singleFlag === 'structural' && state.url.startsWith('/infrastructure/traffic-monitoring')) {
        this.router.navigate(['/home']);
        return false;
      }

      if (singleFlag === 'traffic' && state.url.startsWith('/infrastructure/structural-health')) {
        this.router.navigate(['/home']);
        return false;
      }
    }

    if (activeFlags.length === 0) {
      return this.handleNoActiveFlags(state);
    }

    const allowedRoutes = this.getCombinedAllowedRoutes(activeFlags);

    if (allowedRoutes.some(route => state.url.startsWith(route))) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }

  private getActiveFlags(): string[] {
    const flags = [];
    if (environment.fleet) flags.push('fleet');
    if (environment.aigaleo) flags.push('aigaleo');
    if (environment.mediaServer) flags.push('mediaServer');
    if (environment.agrinio) flags.push('agrinio');
    if (environment.flexi) flags.push('flexi');
    if (environment.structural) flags.push('structural');
    if (environment.traffic) flags.push('traffic');
    if (environment.people) flags.push('people');
    return flags;
  }

  private getCombinedAllowedRoutes(activeFlags: string[]): string[] {
    const allowedRoutes: string[] = [];
    if (activeFlags.includes('fleet')) {
      allowedRoutes.push('/fleet')
    }
    if (activeFlags.includes('aigaleo')) {
      allowedRoutes.push('/aigaleo');
    }
    if (activeFlags.includes('mediaServer')) {
      allowedRoutes.push('/media-server');
    }
    if (activeFlags.includes('agrinio')) {
      allowedRoutes.push('/access-control');
    }
    if (activeFlags.includes('flexi')) {
      allowedRoutes.push('/flexi');
    }
    if (activeFlags.includes('people')) {
      allowedRoutes.push('/home', '/management', '/management/devices', '/stations', '/stations/people');
    }
    if (activeFlags.includes('structural')) {
      allowedRoutes.push('/home', '/management', '/management/devices', '/infrastructure', '/infrastructure/structural-health');
    }
    if (activeFlags.includes('traffic')) {
      allowedRoutes.push('/home', '/management', '/management/devices', '/infrastructure', '/infrastructure/traffic-monitoring');
    }
    return allowedRoutes;
  }

  private handleNoActiveFlags(state: RouterStateSnapshot): boolean {

    if (state.url.startsWith('/access-control') || state.url.startsWith('/media-server') || state.url.startsWith('/aigaleo') || state.url.startsWith('/fleet')) {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
